document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartNote', () => {
    return {
      updating: false,
      init() {
        // 初期化時に送り主名セクションをテキストエリアから削除（表示用）
        // 【贈り主名】〜【/贈り主名】の全体を削除する
        const noteValue = this.$root.value;
        const cleanedNote = noteValue.replace(/【贈り主名】.*?【\/贈り主名】\s*/g, '').trim();
        this.$root.value = cleanedNote;
      },
      updateNote() {
        this.updating = true;
        
        // 送り主名を保持するため、送り主名フィールドから取得
        let noteValue = this.$root.value;
        
        // 送り主名フィールドを探す
        const senderNameInput = document.getElementById('GiftSenderName');
        const senderName = senderNameInput ? senderNameInput.value.trim() : '';
        
        // 送り主名セクションを一時的に削除
        noteValue = noteValue.replace(/【贈り主名】.*?【\/贈り主名】\s*/g, '').trim();
        
        // 送り主名が存在する場合、先頭に追加
        if (senderName) {
          noteValue = `【贈り主名】${senderName}【/贈り主名】` + (noteValue ? '\n\n' + noteValue : '');
        }
        
        fetch(theme.routes.cart_update_url, {
          method: 'POST',
          body: JSON.stringify({
            note: noteValue,
          }),
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
            Accept: 'application/json',
          },
        }).then(() => {
          this.updating = false;
          // テキストエリアには送り主名を含めない（表示用）
          // 【贈り主名】〜【/贈り主名】の全体を削除する
          this.$root.value = noteValue.replace(/【贈り主名】.*?【\/贈り主名】\s*/g, '').trim();
        });
      },
    };
  });

  // ギフト送り主名管理モジュール
  Alpine.data('ThemeModule_GiftSenderName', () => {
    return {
      senderName: '',
      updating: false,
      showSenderNameField: false,
      giftContainer: null,
      observer: null,
      isWatching: false,
      isFocused: false,
      inputTimeout: null,
      
      init() {
        // 既存のカートノートから送り主名を読み込む
        this.loadSenderNameFromNote();
        
        // ギフトコンテナの監視を開始
        this.checkGiftContainer();
        
        // MutationObserverでギフトコンテナの追加を監視
        this.observer = new MutationObserver(() => {
          this.checkGiftContainer();
        });
        
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      },
      
      handleInput() {
        // 入力中は更新を抑制し、フォーカスが外れた時に更新する
        // ただし、長時間入力がない場合は自動保存（3秒後）
        if (this.inputTimeout) {
          clearTimeout(this.inputTimeout);
        }
        
        // フォーカス中でない場合のみ、遅延更新
        if (!this.isFocused) {
          this.inputTimeout = setTimeout(() => {
            this.updateCartNote();
          }, 2000);
        }
      },
      
      loadSenderNameFromNote() {
        // カートノートから送り主名を抽出
        const noteTextarea = document.getElementById('CartSpecialInstructions');
        if (noteTextarea) {
          const noteValue = noteTextarea.value;
          const senderNameMatch = noteValue.match(/【贈り主名】(.*?)【\/贈り主名】/);
          if (senderNameMatch) {
            this.senderName = senderNameMatch[1].trim();
          }
        }
      },
      
      checkGiftContainer() {
        // ギフトコンテナを探す
        const giftContainer = document.querySelector('.sns-gift-new-cart-container');
        
        if (giftContainer && giftContainer !== this.giftContainer) {
          // 新しいコンテナが見つかったら、ラジオボタンの状態を監視
          this.giftContainer = giftContainer;
          this.isWatching = false; // リセット
          this.watchGiftRadio();
        } else if (!giftContainer) {
          this.showSenderNameField = false;
        }
      },
      
      watchGiftRadio() {
        // 既に監視中の場合はスキップ
        if (this.isWatching) {
          return;
        }
        
        // 「指定の住所に贈る」ラジオボタンを探す
        const radioInput = this.giftContainer.querySelector('input[type="radio"][value="none"]');
        
        if (!radioInput) {
          // 要素が見つからない場合、少し待ってから再試行（最大5回）
          if (!this.retryCount) {
            this.retryCount = 0;
          }
          if (this.retryCount < 5) {
            this.retryCount++;
            setTimeout(() => {
              this.watchGiftRadio();
            }, 500);
          }
          return;
        }
        
        this.isWatching = true;
        this.retryCount = 0;
        
        // 初期状態をチェック
        this.updateVisibility(radioInput);
        
        // ラジオボタンの変更を監視
        const handleChange = () => {
          this.updateVisibility(radioInput);
        };
        
        radioInput.addEventListener('change', handleChange);
        
        // ギフトコンテナ内の変更も監視（動的に追加される場合があるため）
        const containerObserver = new MutationObserver(() => {
          // 要素がまだ存在するか確認
          if (this.giftContainer && this.giftContainer.contains(radioInput)) {
            this.updateVisibility(radioInput);
          }
        });
        
        containerObserver.observe(this.giftContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'data-checked']
        });
      },
      
      updateVisibility(radioInput) {
        // 「指定の住所に贈る」が選択されているか確認
        // ラジオボタン自体のchecked属性、または親のlabel要素のdata-checked属性を確認
        const radioLabel = radioInput.closest('label');
        const isRadioChecked = radioInput.checked || 
                              (radioLabel && radioLabel.getAttribute('data-checked') !== null) ||
                              (radioInput.getAttribute('data-checked') !== null);
        
        const shouldShow = isRadioChecked;
        
        // 表示状態が変わった場合のみ処理
        if (this.showSenderNameField !== shouldShow) {
          this.showSenderNameField = shouldShow;
          
          // 非表示になったら送り主名をクリアしてカートノートを更新
          if (!shouldShow) {
            this.senderName = '';
            this.updateCartNote();
          } else if (this.senderName) {
            // 表示になったら、既存の送り主名があればカートノートを更新
            this.updateCartNote();
          }
        }
      },
      
      updateCartNote() {
        // 入力中（フォーカス中）の場合は更新をスキップ
        if (this.isFocused) {
          return;
        }
        
        // タイムアウトをクリア
        if (this.inputTimeout) {
          clearTimeout(this.inputTimeout);
          this.inputTimeout = null;
        }
        
        this.updating = true;
        
        // 現在のカートノートを取得
        const noteTextarea = document.getElementById('CartSpecialInstructions');
        let currentNote = noteTextarea ? noteTextarea.value : '';
        
        // 送り主名のマーカーを削除（既存の送り主名を削除）
        currentNote = currentNote.replace(/【贈り主名】.*?【\/贈り主名】\s*/g, '').trim();
        
        // 送り主名が入力されている場合、カートノートに追加
        if (this.showSenderNameField && this.senderName.trim()) {
          const senderNameSection = `【贈り主名】${this.senderName.trim()}【/贈り主名】`;
          currentNote = senderNameSection + (currentNote ? '\n\n' + currentNote : '');
        }
        
        // カートノートを更新
        fetch(theme.routes.cart_update_url, {
          method: 'POST',
          body: JSON.stringify({
            note: currentNote,
          }),
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
            Accept: 'application/json',
          },
        }).then(() => {
          this.updating = false;
          // テキストエリアには送り主名を含めない（表示用）
          // 【贈り主名】〜【/贈り主名】の全体を削除する
          if (noteTextarea) {
            noteTextarea.value = currentNote.replace(/【贈り主名】.*?【\/贈り主名】\s*/g, '').trim();
          }
        }).catch(() => {
          this.updating = false;
        });
      },
      
      destroy() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    };
  });
});
